import Navbar from "../Components/NavbarItems/Navbar";
import Footer from "../Components/FooterItems/Footer";
import MembershipHome from "../Components/Membership/MembershipHome/MembershipHome";

function Membership() {
  return (
    <>
      <Navbar />
      <MembershipHome />
      <Footer />
    </>
  );
}

export default Membership;
